import React, { useContext } from 'react';

import overviewCards from '../../../core/constants/overview-cards';
import OverviewCard from '../OverviewCard/OverviewCard';

import { OverviewContext } from '../../../core/context/overview-context';

import './Overview.scss';
import Asterix, { AsterixType } from '../../../components/Asterix/Asterix';

export default function Overview(): JSX.Element {
  const overviewData = useContext(OverviewContext);

  return (
    <div className="Overview">
      <div className="Overview__box">
        <div className="Overview__row">
          <div className="Overview__card first">
            <div className="fss">
              <OverviewCard
                config={overviewCards.gas}
                market={overviewData.nbPspot}
                scrollId="gas"
              />
            </div>
          </div>
          <div className="Overview__card second">
            <div className="fcs">
              <OverviewCard
                config={overviewCards.power}
                market={overviewData.ukPowerspot}
                scrollId="power"
              />
            </div>
          </div>
          <div className="Overview__card third">
            <div className="fcs">
              <OverviewCard
                config={overviewCards.oil}
                market={overviewData.brentspot}
                scrollId="brent-oil"
              />
            </div>
          </div>
        </div>
        <div className="Overview__row">
          <div className="Overview__card first">
            <div className="fss">
              <OverviewCard
                config={overviewCards.coal}
                market={overviewData.coalARACIFspot}
                scrollId="coal"
              />
            </div>
          </div>
          <div className="Overview__card second">
            <div className="fce">
              <OverviewCard
                config={overviewCards.green}
                market={overviewData.cO2EUAspot}
                scrollId="carbon"
              />
            </div>
          </div>
          <div className="Overview__card third">
            <div className="fce">
              <OverviewCard
                config={overviewCards.currency}
                market={overviewData.rateGBP_EUR}
                scrollId="currency"
              />
            </div>
          </div>
        </div>
      </div>
      <Asterix type={AsterixType.alter} />
    </div>
  );
}
